<!-- 氏名変更用のパネル -->
<template lang="html">
  <div id="MailAddressChangePanel">
    <h1>メールアドレスの変更</h1>
    <label class="cate2">新しいメールアドレス:
      <input type="text" v-model="new_mail_address">
    </label>
    <button @click="changeMailLocal" class="square_btn">メールアドレスを変更</button>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  data () {
    return {
      new_mail_address: this.current_mail
    }
  },
  props: [
    'user_id',
    'current_mail'
  ],
  methods: {
    ...mapActions([
      'changeMailAddress'
    ]),
    changeMailLocal () {
      this.changeMailAddress({
        id: this.user_id,
        newMailAddress: this.new_mail_address
      }).then((res) => {
        if (res) {
          this.$emit('ehanged')
          alert('変更に成功しました')
        }
      })
    }
  }
}
</script>

<style lang="css" scoped>
label {
  display: block;
}
#MailAddressChangePanel {
  width: 900px;
  margin-top: 10px;
  padding-top:30px;
  margin-left: auto;
  margin-right: auto;
  /*
  border-style: solid;
  border-color: #E69200;
  border-left: none;
  border-right: none;
  border-bottom: none;
  */
}

h1 {
  padding: 0.5em;
  background: aliceblue;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.23);
  width: 600px;
  margin: auto;
  margin-top: 15px;
  margin-bottom: 15px;
  padding-top: 3px;
  padding-bottom: 3px;
  font-family: "メイリオ", "ヒラギノ丸ゴ ProN", sans-serif;
  font-size: 18px;
}
.cate2 {
  font-family: "メイリオ", "ヒラギノ丸ゴ ProN", sans-serif;
  font-size: 14px;
  margin-bottom: 15px;
  color: #5B5B5B;
}
input {
  border:0;
  font-size:14px;
  font-family:Arial, sans-serif;
  color:#505050;
  border:solid 1px #ccc;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
  padding-top: 3px;
  padding-bottom: 3px;
  width : 200px;
}
input:focus {
  border:solid 1px #EEA34A;
}
.square_btn {
    margin-top: 13px;
    font-size: 14px;
    position: relative;
    display: inline-block;
    padding: 0.25em 0.5em;
    text-decoration: none;
    color: #FFF;
    background: #FFCC33;/*背景色*/
    border-bottom: solid 2px #d27d00;/*少し濃い目の色に*/
    border-radius: 4px;/*角の丸み*/
    box-shadow: inset 0 2px 0 rgba(255,255,255,0.2), 0 2px 2px rgba(0, 0, 0, 0.19);
}

.square_btn:active {
    border-bottom: solid 2px #fd9535;
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.30);
}
</style>



// WEBPACK FOOTER //
// MailAddressChangePanel.vue?f408e33c